module.exports = __webpack_public_path__ + "img/experience3.4b454621.png";